import ErrorSvg from '@/assets/500.svg?react';
import { Button, Typography } from '@propify/admin-components';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

const ErrorPage: FC = () => {
  const navigate = useNavigate();

  const handleBackHome = () => navigate('/');

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '24px',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <ErrorSvg />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '24px',
        }}
      >
        <Typography variant="h3" style={{ textAlign: 'center', marginBottom: 12 }}>
          Unexpected Error
        </Typography>
        <Typography variant="body" style={{ textAlign: 'center', marginBottom: 32 }}>
          Sorry, the page you visited has thrown an unexpected error.
        </Typography>
        <div style={{ textAlign: 'center' }}>
          <Button onClick={handleBackHome}>Back Home</Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
